<aside class="border-surface-100 flex h-full w-full flex-col border-r bg-white px-6 py-8" id="sidebar">
	<div class="mb-8 flex items-center justify-center">
		<svg-icon src="./assets/images/logo-small.svg" name="sidebar-logo"></svg-icon>
	</div>

	<div class="grow overflow-auto">
		@if(auth.workgroup()) {
		<div class="flex w-full items-center gap-2.5">
			<div class="border-surface-100 size-6 overflow-hidden rounded-sm border">
				<img
					class="size-full object-cover"
					[src]="auth.workgroup()?.logo"
					appImgFallback
					alt="workgroup logo"
				/>
			</div>
			<div class="grow truncate text-sm">{{auth.workgroup()?.name||'Workgroup'}}</div>
			<p-menu #menu [model]="workgroupMenu" [popup]="true" appendTo="#sidebar-wrapper">
				<ng-template #item let-item>
					<a class="p-menu-item-link flex items-center gap-2" [routerLink]="item.routerLink">
						@if(item.icon) {
						<svg-icon [src]="item.icon" class="text-secondary size-3.5"></svg-icon>
						} {{item.label | translate}}
					</a>
				</ng-template>
			</p-menu>
			<p-button
				#menuButton
				icon="pi pi-ellipsis-v"
				[rounded]="true"
				[text]="true"
				severity="contrast"
				(click)="menu.toggle($event)"
				(keydown.enter)="menu.toggle($event)"
				(keydown.space)="menu.toggle($event); $event.preventDefault()"
			/>
		</div>
		<p-divider class="py-1" />
		}

		<ul class="flex grow flex-col gap-4 text-sm">
			@for (item of mainMenu ; track item.label) { @if (item.items && item.items.length) {
			<p-accordion [value]="0">
				<p-accordion-panel class="border-none" [value]="item.label">
					<p-accordion-header
						class="hover:bg-surface-100 text-main flex items-center gap-2 px-2.5 py-2 leading-0 font-normal [&_.p-icon]:size-3.5"
					>
						@if(item.icon) {
						<svg-icon [src]="item.icon" class="text-secondary size-3.5"></svg-icon>
						}
						<span class="grow">{{item.label | translate}}</span>
					</p-accordion-header>
					<p-accordion-content class="[&_.p-accordioncontent-content]:p-0">
						<ul class="flex flex-col gap-2 py-2 text-sm">
							@for (child of item.items ; track child.label) {
							<li class="p-menu-item">
								<a
									[routerLink]="child.routerLink"
									routerLinkActive="bg-surface-100"
									class="hover:bg-surface-100 flex min-h-7 items-center gap-2 rounded-sm leading-0"
								>
									<span class="ml-5 grow">{{child.label | translate}}</span>
								</a>
							</li>
							}
						</ul>
					</p-accordion-content>
				</p-accordion-panel>
			</p-accordion>

			} @else {
			<li class="p-menu-item">
				<div class="p-menu-item-content">
					<a
						[routerLink]="item.routerLink"
						routerLinkActive="bg-surface-100"
						class="hover:bg-surface-100 flex min-h-7 items-center gap-2 rounded-sm px-2.5 py-2 leading-0"
					>
						@if(item.icon) {
						<svg-icon [src]="item.icon" class="text-secondary size-3.5"></svg-icon>
						}
						<span class="grow">{{item.label | translate}}</span>
					</a>
				</div>
			</li>
			} }
		</ul>
	</div>

	<div class="flex flex-col gap-8 pt-6">
		<div class="flex items-center justify-center gap-2.5 overflow-hidden">
			<span class="truncate text-sm">{{auth.userEmail()}}</span>
			<a routerLink="/logout" class="text-secondarys text-2xl">
				<i class="pi pi-sign-out"></i>
			</a>
		</div>
		<div class="text-secondary text-center text-sm">{{ 'COMMON.VERSION' | translate }} {{version}}</div>
	</div>
</aside>
